export interface IInitChatAnywhereProps {
  locale: string;
  pageName?: string;
  pageSection?: string;
  pagePage?: string;
  tenant?: string;
}

export const ubikEnabledPages = [
  'Special Offers',
  'My Projects',
  'Checkout',
  'promotionalProducts:Category Page',
  'clothingAndBags:Category Page',
  'carepageppag:Category Page',
  'promotionalproductsfreesamplesforbusinesses:Category Page',
  'My Uploads',
  'Design Services:Hub Page',
  'Configure - Mailing Add List',
  'Configure - Mailing List Selection',
  'Configure - Mailing Upload Review',
  'Configure - Mailing Shipping',
  'Configure - Mailing Upsell',
  'Studio',
];

export const miawEnabledLocales = [
  'en-sg',
  'en-nz',
  'en-au',
  'en-ie',
  'fi-fi',
  'sv-se',
  'da-dk',
  'nb-no',
  'de-de',
  'de-at',
  'es-es',
  'it-it',
  'nl-nl',
  'nl-be',
  'it-ch',
  'de-ch',
  'fr-ch',
  'fr-fr',
  'fr-be',
  'fr-ca',
  'en-ca',
  'en-gb',
];
